
import React from 'react';
import { CardHeader, CardTitle } from "@/components/ui/card";
import { LucideIcon } from 'lucide-react';
import { TooltipProvider, Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { Syringe, Pill as PillIcon, Droplet } from 'lucide-react';

interface MedicationCardHeaderProps {
  name: string;
  Icon: LucideIcon;
  availablePreparations?: string;
}

const MedicationCardHeader: React.FC<MedicationCardHeaderProps> = ({ 
  name, 
  Icon, 
  availablePreparations 
}) => {
  const getDosageFormIcons = (text: string) => {
    if (!text) return null;
    
    const icons = [];
    
    if (text.toLowerCase().includes('injection')) {
      icons.push(
        <TooltipProvider key="syringe-tooltip">
          <Tooltip>
            <TooltipTrigger asChild>
              <span>
                <Syringe key="syringe" className="h-4 w-4 text-white" />
              </span>
            </TooltipTrigger>
            <TooltipContent>
              <p>Injectable form available</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      );
    }
    
    if (text.toLowerCase().includes('pill') || 
        text.toLowerCase().includes('tablet') || 
        text.toLowerCase().includes('capsule')) {
      icons.push(
        <TooltipProvider key="pill-tooltip">
          <Tooltip>
            <TooltipTrigger asChild>
              <span>
                <PillIcon key="pill" className="h-4 w-4 text-white" />
              </span>
            </TooltipTrigger>
            <TooltipContent>
              <p>Oral pill/tablet/capsule form available</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      );
    }
    
    if (text.toLowerCase().includes('cream') || 
        text.toLowerCase().includes('ointment') || 
        text.toLowerCase().includes('solution') || 
        text.toLowerCase().includes('topical')) {
      icons.push(
        <TooltipProvider key="droplet-tooltip">
          <Tooltip>
            <TooltipTrigger asChild>
              <span>
                <Droplet key="droplet" className="h-4 w-4 text-white" />
              </span>
            </TooltipTrigger>
            <TooltipContent>
              <p>Topical/cream/ointment form available</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      );
    }
    
    if (text.toLowerCase().includes('troche') || 
        text.toLowerCase().includes('sublingual')) {
      icons.push(
        <TooltipProvider key="troche-tooltip">
          <Tooltip>
            <TooltipTrigger asChild>
              <span>
                <PillIcon key="troche" className="h-4 w-4 text-white rotate-45" />
              </span>
            </TooltipTrigger>
            <TooltipContent>
              <p>Sublingual/troche form available</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      );
    }
    
    return icons;
  };

  return (
    <CardHeader className="p-4 bg-primary text-white rounded-t-lg">
      <div className="flex items-center justify-between">
        <CardTitle className="text-lg md:text-xl text-white">{name}</CardTitle>
        {availablePreparations && (
          <div className="flex items-center gap-2">
            {getDosageFormIcons(availablePreparations)}
          </div>
        )}
      </div>
    </CardHeader>
  );
};

export default MedicationCardHeader;
